import Presentation from "./presentation";

const CreatorPlusProfileNew = props => {
	const {
		profile,
		// ugcStats, // check if we really need this
		userId,
		activeTab,
		activeTabData,
		deletionTime,
		streamsToDelete = [],
		totalNoOfStreams = 0
	} = props;

	return (
		<Presentation
			activeTab             = { activeTab }
			activeTabData         = { activeTabData }
			deletionTime          = { deletionTime }
			streamsToDelete       = { streamsToDelete }
			totalNoOfStreams      = { totalNoOfStreams }
			userId                = { userId }
			userProfile           = { profile }
		/>
	);
};

export default CreatorPlusProfileNew;
